import React from 'react';
import PropTypes from "prop-types";
import { QueryRenderer, graphql } from 'react-relay';
import RelayService from '../../service/RelayService';
import Clip from './Clip';

export default class ClipLoader extends React.Component {

  static propTypes = {
    disableSuggest: PropTypes.bool,
  };

  render() {
    let {disableSuggest} = this.props;

    return (
      <QueryRenderer
        environment={RelayService.environment}
        query={graphql`
        query ClipLoaderQuery {
            viewer {
                ...Clip_viewer
            }
        }
      `}
        render={({ error, props }) => {
          if (error) {
            return <div>{error.message}</div>;
          } else if (props) {
            console.log('ClipLoader', props)
            return (
              <Clip viewer={props.viewer} {...this.props} />
            );
          }
          return (
            <div>Loading Clip</div>
          );
        }}
      />
    )
  }

}
